import React from 'react';
import ReactJson from 'react-json-view'
import { makeStyles } from '@mui/styles';

const JsonViewer = ({ data }) => {
  const useStyles = makeStyles((theme) => ({
    jsonViewer: {
       width:"60%"
    },
  }));

  const classes = useStyles();
    return (
      <ReactJson src={data} theme="rjv-default" collapsed={false} />
     
    );
  };
  
  export default JsonViewer;
  